import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {TopicLayerConfiguration} from "../../config/topic-configuration";
// *Geo.js Properties*
@JsonObject()
export class CompareMatrixConfiguration {

    @JsonProperty()
    declare layers: TopicLayerConfiguration[];

    @JsonProperty()
    declare default?: boolean;

    @JsonProperty()
    declare defaultTrailing?: boolean;

    @JsonProperty()
    declare disableNext?: boolean;

    constructor() {}
}
@JsonObject()
export class CompareSliderConfiguration {

    @JsonProperty()
    declare label: string;

    @JsonProperty()
    declare tooltip?: string;

    constructor() {}
}
@JsonObject()
export class CompareConfiguration {

    @JsonProperty()
    declare layerMetauids: string[];

    @JsonProperty()
    declare optional?: string[];

    @JsonProperty()
    declare permanent?: string[];

    @JsonProperty()
    declare style?: "default" | "slider";
    /**
     * Mögliche Layer IDs pro Subtopic. Falls nicht definiert, werden alle zugelassen.
     */
    @JsonProperty()
    declare subtopics?: HashMap<TopicLayerConfiguration[]>;

    /**
     * URL
     */
    @JsonProperty()
    declare layerMatrix: HashMap<HashMap<CompareMatrixConfiguration>>;

    @JsonProperty()
    declare slider?: HashMap<HashMap<CompareSliderConfiguration>>;

    constructor() {}
}

